import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import i18next from 'i18next'
import App from './App.tsx'
import store from './store'
import '../i18n.ts'
import { registerSW } from 'virtual:pwa-register'

// Register service worker with auto-reload on update
registerSW({
  immediate: true,
  onNeedRefresh() {
    // New content available, reload automatically
    window.location.reload()
  },
  onOfflineReady() {
    console.log('App ready to work offline')
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <I18nextProvider i18n={i18next}>
        <App />
      </I18nextProvider>
    </Provider>
  </StrictMode>
)
